var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[("box-icon " + _vm.size)]},[_c('img',{staticClass:"mb-3",attrs:{"src":("/img/" + _vm.image)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }